import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/core/services/data.service';
import { GlobalCreditConfig } from '../models/global-credit-config.model';
import { GlobalCreditConfigSeedData } from '../models/global-credit-config-seed-data.model';

@Injectable({
  providedIn: 'root',
})
export class CreditConfigService {
  constructor(private readonly _dataService: DataService) {}

  getGlobalCreditConfigList = (): Observable<GlobalCreditConfig[]> => {
    return this._dataService.get(`api/super-admin/global-credit-config`);
  };

  getTpoGlobalCreditConfigList = (): Observable<GlobalCreditConfig[]> => {
    return this._dataService.get(`api/tpoconfiguration/global-credit-config`); 
  }

  insertGlobalCreditConfig = (
    creditConfig: GlobalCreditConfig
  ): Observable<GlobalCreditConfig> => {
    return this._dataService.post(
      `api/super-admin/global-credit-config`,
      creditConfig
    );
  };

  updateGlobalCreditConfig = (
    creditConfig: GlobalCreditConfig
  ): Observable<GlobalCreditConfig> => {
    return this._dataService.post(
      `api/super-admin/global-credit-config/${creditConfig.id}`,
      creditConfig
    );
  };

  getGlobalCreditConfigSeedData = (
    id: number,
    isNewRow: boolean
  ): Observable<GlobalCreditConfigSeedData> => {
    return this._dataService.get(
      `api/super-admin/global-credit-config/${id}/seed-data?isNewRow=${isNewRow}`
    );
  };

  deleteGlobalCreditConfig = (id: number): Observable<any> => {
    return this._dataService.delete(
      `api/super-admin/global-credit-config/${id}`
    );
  };
}
